import Vue from 'vue';
import VueCookies from 'vue-cookies';
import { KEYS } from '@/utils/constants';
// Registro de Cookies
Vue.use(VueCookies);
export const state = {
    packageCoin: Vue.$cookies.get(KEYS.PACKAGE_ID) != undefined ? Vue.$cookies.get(KEYS.PACKAGE_ID) : null,
};
export const mutations = {
    SET_PACKAGE_ID(state, obj) {
        state.packageCoin = obj;
        Vue.$cookies.set(KEYS.PACKAGE_ID, state.packageCoin);
    }
};
export const actions = {
    async setPackageCoin({ commit }, packageCoin) {
        await commit('SET_PACKAGE_ID', packageCoin);
    }
};
